module.exports = __webpack_public_path__ + "static/sung-thumb-bfecb8973151ae4be7541bc35bef47ca.png";